import React from 'react';
import './RoutingMod.scss';

const RoutingMod = () => {
  return (
    <div className="main-right-side-section">
      <div className="routingmod-main-section">
        <section>
          <div className="routingmod-section-1">
            <div className="routingmod-section-1-inner">
              <p>Routing Module</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

RoutingMod.propTypes = {};

RoutingMod.defaultProps = {};

export default RoutingMod;
